<script setup lang="ts">
import { ref, reactive, onMounted, defineAsyncComponent } from "vue";
import { LocationQueryValueRaw, useRoute } from "vue-router";
import { CurrentCode } from "@/api/currentCode";
import { Activity, activityResponse, GroupShareResponse } from "@/api/activity";
import { Button } from "vant";
import { allCountries } from "@/components/IndexBarCode/data/country";
import store from "store2";
import { getCookie } from "@/utils/service/request";
import useShare from "./hooks/useShare";
import { WxTicket } from "@/api/wxTicket";
import {
  initConfig,
  updateAppMessageShareData,
  updateTimelineShareData,
} from "@/hooks/useWxSDK";
import { useRouter } from "vue-router";
const router = useRouter();
//接口定义
interface DefineCode {
  countryCode: string; //国家代码 "CN"
  code: string; // 区号 "86"
}
interface RuleDesc {
  title: string;
  content: string;
}
//CSS 接口
type Cls = {
  two: boolean;
  three: boolean;
  process_wrapper_item_five: boolean;
  process_wrapper_item_four: boolean;
  process_wrapper_item_three: boolean;
  process_wrapper_item_two: boolean;
};
type BoxFlag = {
  six_box: boolean;
  five_box: boolean;
};
const LoginGet = defineAsyncComponent(
  () => import("@/components/LoginGet.vue")
);
// const props = defineProps<{ pid: string }>();
//变量和函数定义
const route = useRoute();
const flag: Cls = reactive({
  two: false,
  three: false,
  process_wrapper_item_five: false,
  process_wrapper_item_four: false,
  process_wrapper_item_three: false,
  process_wrapper_item_two: false,
});
const boxFlag: BoxFlag = reactive({
  six_box: false,
  five_box: false,
});
const actionSheetStatus = ref<boolean>(false);
const defineCode = reactive<DefineCode>({
  countryCode: "CN",
  code: "86",
});
const activityInfo = reactive<activityResponse>({
  userId: 0,
  id: 0,
  h5Title: "", //h5标题
  bannerUrls: "",
  price: 0, //活动标价
  scribingPrice: 0, //划线价
  activityTitle: "", //活动标题
  endTime: 0, //	结束时间(时间戳)
  activityProcess: "", //	活动流程
  ruleDesc: "", //规则说明
  detailsImgurl: "", //	详情页图片
  footBtnText: "", //底部按钮文案
  openGroupExplain: "", //开团说明
  joinPeopleNum: 0, //参与人数
});
const activityProcessArr = ref<Array<string>>([]);
const activityTitleArr = ref<Array<string>>([]);
const bannerUrlsArr = ref<Array<string>>([]);
const ruleDescArr = ref<Array<RuleDesc>>([]);

const d = ref<number>();
const h = ref<number>(0);
const m = ref<number>(0);
const s = ref<number>(0);
const getTimeFunc = () => {
  //获取当前时间
  let nowTime = new Date().getTime();
  const time = new Date(activityInfo.endTime);
  // console.log(time)
  const end = time.getTime();
  //时间差
  let gapTime = end - nowTime;
  // console.log(gapTime)
  if (gapTime >= 0) {
    d.value = Math.floor(gapTime / 1000 / 60 / 60 / 24);
    h.value = Math.floor((gapTime / 1000 / 60 / 60) % 24);
    m.value = Math.floor((gapTime / 1000 / 60) % 60);
    s.value = Math.floor((gapTime / 1000) % 60);
  }
};
setInterval(getTimeFunc, 1000);
const show = ref<boolean>(false);
const showRule = () => {
  show.value = true;
};
const { aid, pid } = route.query;
const { isWeixin } = useShare();
function setCookie(cookiename: any, cookievalue: any) {
  const date = new Date();
  // if (type === 'milsecond') {
  //   date.setTime(date.getTime() + milsecond)
  // } else {
  date.setDate(date.getDate() + 99999);
  // }
  document.cookie =
    cookiename +
    "=" +
    cookievalue +
    ";expires = " +
    date.toUTCString() +
    ";path=/";
}
const shareInfo = reactive<GroupShareResponse>({
  id: 0, //id
  shareTitle: "", //分享标题
  shareText: "", //分享文本
  shareImgUrl: "", //分享图片
});
const isTrue = ref<LocationQueryValueRaw | LocationQueryValueRaw[]>();

onMounted(async () => {
  try {
    const res = await CurrentCode.getAreacode(); //获取国家代码和国家名称
    for (const item of allCountries) {
      if (
        res.code.toUpperCase() === item[1].toUpperCase() ||
        res.name === item[3]
      ) {
        defineCode.countryCode = item[1]; //国家代码 "CN"
        defineCode.code = item[2]; //区号 "86"
      }
    }
  } catch (error) {
    console.log(error);
  }
  
  try {
    const res = await Activity.activityGet({ id: Number(aid) });
    activityInfo.userId = res.userId;
    activityInfo.id = res.id;
    const xxx = getCookie("aid");
    console.log(xxx);
    if (xxx === aid && activityInfo.userId) {
      window.location.href = `/startGroup/${activityInfo.userId}?aid=${
        activityInfo.id
      }&isLogin=${true}&isAuto=${true}`;
    }
    // if (activityInfo.userId) {
    //   console.log("8888888");
    //   router.push({
    //     path: `/startGroup/${activityInfo.userId}`,
    //     query: {
    //       aid: activityInfo.id,
    //       isLogin: ,
    //     },
    //   });
    activityInfo.h5Title = res.h5Title;
    document.title = res.h5Title;
    activityInfo.price = res.price;
    activityInfo.scribingPrice = res.scribingPrice;
    activityInfo.activityTitle = res.activityTitle;
    activityInfo.activityProcess = res.activityProcess;
    activityInfo.detailsImgurl = res.detailsImgurl;
    activityInfo.footBtnText = res.footBtnText;
    activityInfo.joinPeopleNum = res.joinPeopleNum;
    activityInfo.endTime = res.endTime;
    activityInfo.bannerUrls = res.bannerUrls;
    activityInfo.ruleDesc = res.ruleDesc;

    activityProcessArr.value = activityInfo.activityProcess.split("#");
    if (activityProcessArr.value[activityProcessArr.value.length - 1] === "") {
      activityProcessArr.value.pop();
    }

    activityTitleArr.value = activityInfo.activityTitle.split("#");
    bannerUrlsArr.value = activityInfo.bannerUrls.split(",");
    ruleDescArr.value = JSON.parse(activityInfo.ruleDesc);
    const length = activityProcessArr.value.length;
    if (length === 6) {
      boxFlag.six_box = true;
    } else if (length === 5) {
      flag.process_wrapper_item_five = true;
      boxFlag.five_box = true;
    } else if (length === 4) {
      flag.process_wrapper_item_four = true;
    } else if (length === 3) {
      flag.process_wrapper_item_three = true;
    } else if (length === 2) {
      flag.process_wrapper_item_two = true;
    } else {
      return flag;
    }
  } catch (error) {
    console.log(error);
  }

  if (isWeixin()) {
    const resShare = await Activity.groupShare({ id: Number(aid) });
    shareInfo.shareTitle = resShare.shareTitle;
    shareInfo.shareText = resShare.shareText;
    shareInfo.shareImgUrl = resShare.shareImgUrl;
    const { ticket } = await WxTicket.getWxTicket();
    await initConfig(
      {
        appId: process.env.VUE_APP_WX_APP_ID as string,
        timestamp: parseInt(String(new Date().getTime() / 1000)), //时间戳
        nonceStr: "asdfaskldjflkajskd", //随机字符串
      },
      ticket,
      window.location.href
    );
    const shareParams = {
      title: shareInfo.shareTitle, // 分享标题
      desc: shareInfo.shareText, // 分享描述
      link: window.location.href, //分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareInfo.shareImgUrl, //分享图标
      success() {
        // 用户确认分享后执行的回调函数
        console.log("success");
      },
      cancel() {
        // 用户取消分享后执行的回调函数
        console.log("cancel");
      },
    };
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    updateAppMessageShareData(shareParams);
    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    updateTimelineShareData(shareParams);
  }
});
function HelpClick() {
  actionSheetStatus.value = true;
}
</script>

<template>
  <div class="container-layout">
    <div class="container-layout-wrapper">
      <div class="container-top">
        <van-swipe :autoplay="3000" lazy-render>
          <van-swipe-item v-for="item in bannerUrlsArr" :key="item">
            <template v-if="item.search('.mp4') != -1">
              <video controls :src="item"></video>
            </template>
            <template v-else>
              <img :src="item" alt="" />
            </template>
          </van-swipe-item>
          <template #indicator="{ active, total }">
            <div class="custom-indicator">{{ active + 1 }}/{{ total }}</div>
          </template>
        </van-swipe>
      </div>
      <div class="content-two">
        <div class="left-wrapper">
          <div class="current-price">
            <span>$</span>
            <span class="current-price-big">
              {{ activityInfo.price }}
            </span>
          </div>
          <div class="recovery">
            即将恢复原价${{ activityInfo.scribingPrice }}
          </div>
        </div>

        <div class="last-time">
          <div class="last-time-top">
            距离结束还剩
            <span class="last-time-block">
              {{ d }}
            </span>
            天
          </div>
          <div class="last-time-bottom">
            <span class="last-time-block"> {{ h }}</span>
            <span class="last-time-block-maohao">
              <img src="../../assets/activity/pages/maohao.svg" alt="" />
            </span>
            <span class="last-time-block"> {{ m }}</span>
            <span class="last-time-block-maohao">
              <img src="../../assets/activity/pages/maohao.svg" alt="" />
            </span>
            <span class="last-time-block">{{ s }}</span>
          </div>
        </div>
      </div>
      <div class="content-three">
        <div class="content-three-title">
          <p>{{ activityTitleArr[0] }}</p>
          <p>{{ activityTitleArr[1] }}</p>
        </div>
        <div class="content-three-join">
          已有
          <span class="content-three-join-number">
            {{ activityInfo.joinPeopleNum }}
          </span>
          人参与成功
        </div>
      </div>
      <div class="content-process">
        <div class="content-four-top">
          <div class="content-four-top-content">
            <div class="process">活动流程</div>
            <div class="rule">
              <span @click="showRule">
                规则说明
                <img src="../../assets/activity/pages/arrow.svg" alt="" />
              </span>
              <van-popup
                round
                v-model:show="show"
                closeable
                position="bottom"
                :style="{ height: '60%' }"
              >
                <div class="popup-title">
                  <img src="../../assets/activity/pages/rule.png" alt="" />
                </div>
                <ul class="popup-content">
                  <li v-for="item of ruleDescArr" :key="item.title">
                    <div class="popup-content-title">
                      <span class="popup-content-title-circle"></span>
                      {{ item.title }}
                    </div>
                    <div class="popup-content-item">
                      {{ item.content }}
                    </div>
                  </li>
                </ul>
              </van-popup>
            </div>
          </div>
        </div>
        <!-- 活动流程内容部分 -->
        <div :class="['content-four-wrapper', boxFlag]">
          <div
            class="process-wrapper"
            v-for="(item, index) in activityProcessArr"
            :key="index"
          >
            <div class="process-wrapper-box">
              <div :class="[flag, 'process_wrapper_item']">
                {{ item }}
              </div>
              <!-- 序号 -->
              <span class="process-wrapper-order">{{ index + 1 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-five">
        <div class="content-five-title">
          <span></span>
          活动详情
          <span></span>
        </div>
        <div class="content-five-content">
          <img :src="activityInfo.detailsImgurl" alt="" />
        </div>
      </div>
    </div>

    <div class="content-footer">
      <Button class="help-button" @click="HelpClick" block>
        {{ activityInfo.footBtnText }}
      </Button>
    </div>
  </div>
  <login-get
    :aid="aid"
    :pid="pid"
    :define-code="defineCode"
    v-model:actionSheetStatus="actionSheetStatus"
    v-if="actionSheetStatus"
  />
</template>

<style lang="less" scoped>
.popup-title {
  margin: 20px auto 40px auto;
  width: 176px;
  height: 34px;
  text-align: center;
  img {
    width: 100%;
  }
}
.popup-content {
  font-family: JiangChengYuanTi;
  padding-left: 21px;
  padding-right: 21px;
  li {
    margin-bottom: 20px;
    .popup-content-title {
      color: rgba(0, 0, 0, 0.9);
      font-size: 16px;
      font-weight: 600;
      line-height: 23px;
      color: rgba(0, 0, 0, 0.9);
      display: flex;
      align-items: center;
      .popup-content-title-circle {
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-right: 7px;
        background: #ff7733;
        border-radius: 50%;
      }
    }
    .popup-content-item {
      font-size: 12px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.6);
      margin-left: 13px;
    }
  }
}
.container-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f8f8f8;
}
.container-layout-wrapper {
  overflow: auto;
  flex-grow: 1;
}
.container-top {
  position: relative;
  height: 196px;
  width: 100%;
  img {
    width: 100%;
    height: 196px;
  }
  video {
    width: 100%;
    height: 196px;
  }
}
/deep/.custom-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 37px;
  height: 22px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 2px 5px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.3);
  opacity: 1;
  border-radius: 12px;
}
.content-two {
  display: flex;
  height: 68px;
  width: 100%;
  background-image: url("../../assets/activity/pages/background.png");
  background-repeat: no-repeat;
  background-size: 100%;
  .current-price {
    padding-top: 4px;
    text-align: center;
    color: #fff;
    height: 39px;
    width: 50px;
    padding-bottom: 5px;
    font-size: 12px;
    margin-left: 57px;
    .current-price-big {
      font-size: 32px;
      margin-left: 5px;
    }
  }
  .recovery {
    font-size: 10px;
    font-family: JiangChengYuanTi;
    line-height: 21px;
    color: #845600;
    text-align: center;
    width: 104px;
    height: 21px;
    margin-left: 40px;
    background-image: url("../../assets/activity/pages/bac-2.png");
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .last-time {
    // border: 1px solid blue;
    width: 130px;
    height: 52px;
    margin-left: 90px;
    margin-top: 9px;
    font-size: 12px;
    .last-time-top {
      // border: 1px solid blue;
      text-align: center;
      height: 20px;
      font-family: JiangChengYuanTi;
      font-weight: 500;
      line-height: 23px;
      color: rgba(0, 0, 0, 0.6);
      opacity: 1;
    }
    .last-time-bottom {
      height: 32px;
      font-family: JiangChengYuanTi;
      font-weight: 500;
      line-height: 23px;
      color: rgba(0, 0, 0, 0.6);
      opacity: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.last-time-block {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: #ff2929;
  border-radius: 4px;
  color: #fff;
}
.last-time-block-maohao {
  display: inline-block;
  height: 18px;
  width: 20px;
  text-align: center;
  img {
    display: inline-block;
    width: 120%;
    margin: 0 auto;
    height: 100%;
  }
}
.content-three {
  width: 100%;
  height: 104px;
  background: #ffffff;
  opacity: 1;
  padding-top: 14px;
  .content-three-title {
    height: 48px;
    width: 205px;
    font-size: 18px;
    font-family: JiangChengYuanTi;
    font-weight: 600;
    line-height: 23px;
    color: rgba(0, 0, 0, 0.8);
    margin-left: 20px;
  }
  .content-three-join {
    padding-left: 20px;
    height: 16px;
    font-size: 12px;
    font-family: JiangChengYuanTi;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.4);
    margin-top: 6px;
    .content-three-join-number {
      color: #ff7733;
    }
  }
}
// 活动流程
.content-process {
  margin-top: 10px;
  width: 100%;
  padding: 0 23px 0 20px;
  background: #ffffff;
  max-height: 280px;
  // justify-content: space-between;
  // justify-content: center;
  .content-four-top {
    height: 46px;
    .content-four-top-content {
      padding: 17px 0 11px 0;
      width: 100%;
      height: 100%;
      font-family: JiangChengYuanTi;
      font-size: 14px;
      font-weight: 500;
      line-height: 23px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.039);
      display: flex;
      justify-content: space-between;
      .process {
        color: rgba(0, 0, 0, 0.8);
      }
      .rule {
        height: 18px;
        color: rgba(0, 0, 0, 0.41);
      }
    }
  }

  .content-four-wrapper {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .process-wrapper-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
      .process_wrapper_item {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 105px;
        height: 60px;
        line-height: 20px;
        background: #fff5f0;
        border-radius: 8px;
        font-size: 11px;
        font-family: JiangChengYuanTi;
        color: rgba(0, 0, 0, 0.8);
        margin-bottom: 5px;
        padding: 0 8px;
      }
      // 5个流程
      .process_wrapper_item_five {
        margin: 0 4px 5px 4px;
        width: 100px;
      }
      // 4个流程
      .process_wrapper_item_four {
        width: 74px;
        height: 80px;
        line-height: 20px;
      }
      //3个流程
      .process_wrapper_item_three {
        width: 102px;
      }
      //2个流程
      .process_wrapper_item_two {
        width: 158px;
      }
      //序号
      .process-wrapper-order {
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #ff7733;
        color: #fff;
        text-align: center;
        font-size: 10px;
        font-weight: normal;
        line-height: 16px;
      }
    }
  }
  .six_box {
    justify-content: space-between;
  }
  .five_box {
    justify-content: center;
  }
}
//活动详情
.content-five {
  width: 100%;
  max-height: 800px;
  margin-top: 11px;
  .content-five-title {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
      width: 30px;
      height: 1px;
      background: #ff7733;
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }
  .content-five-content {
    img {
      width: 100%;
      object-fit: fill;
    }
  }
}
.content-footer {
  width: 100%;
  height: 76px;
  .help-button {
    display: block;
    width: 335px;
    height: 50px;
    background: linear-gradient(90deg, #ff2929 0%, #ff7600 100%);
    border-radius: 27px;
    font-size: 18px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    font-weight: 400;
    margin: 13px auto;
    border: none;
  }
}
.help-top {
  width: 100%;
}
.container-content {
  position: absolute;
  bottom: -30px;
  width: 335px;
  left: 50%;
  margin-left: -167.5px;
  min-height: 135px;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
  li {
    &:first-child {
      width: 98px;
      height: 135px;
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
      position: absolute;
      top: -20px;
      /deep/.van-image {
        width: 98px;
        height: 135px;
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
      }
    }
    &:last-child {
      min-width: 168px;
      height: 95px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 116px;
      h2 {
        font-size: 16px;
        line-height: 22px;
        color: #16212e;
      }
      p {
        font-size: 12px;
        line-height: 22px;
        color: #ff8000;
        padding: 10px 8px;
        background: #fff1df;
        border-radius: 15px;
        text-align: center;
      }
    }
  }
}
.footer {
  position: absolute;
  bottom: 20px;
  width: 100vw;
  h3 {
    font-size: 12px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.2);
    text-align: center;
  }
  img {
    display: block;
    width: 78px;
    margin: 0 auto;
  }
}
</style>
